<template>
  <div class="componentLoader">
    <component :is="useCom" ref="cominstance" :menuCode="menuCode"></component>
  </div>
</template>

<script>
// import WorkSpace from "./home/WorkSpace"
//数据中心

import payTotal from "./dataCenter/payTotal.vue"; //应收账款
// import payProjectDeptDataSingle from "./dataCenter/payProjectDeptDataSingle"; //项目部看板
// import payProjectData from "./dataCenter/payProjectData"; //项目看板数据
import payDataSource from "./dataCenter/payDataSource"; //应收账款数据源
import accountsReceiveTotal from "./dataCenter/accountsReceiveTotal.vue"; //付款申请

// import receiveProjectDeptDataSingle from "./dataCenter/accountsReceiveDeptDataSingle"; //付款申请项目部看板数据
// import receiveProjectData from "./dataCenter/accountsReceiveDataSource"; //付款申请项目看板数据
import accountsReceiveDataSource from "./dataCenter/accountsReceiveDataSource"; //付款申请数据源

import payTotalA from "./dataCenterA/payTotal.vue"; //应收账款(实际数据)
// import payDataSourceRe from "./dataCenterRe/payDataSource"; //应收账款数据源(实际数据)
import accountsReceiveTotalA from "./dataCenterA/accountsReceiveTotal.vue"; //付款申请(实际数据)
// import accountsReceiveDataSourceRe from "./dataCenterRe/accountsReceiveDataSource"; //付款申请数据源(实际数据)

import costTotal from "./dataCenterA/profit/costTotal.vue"; //收入成本毛利(实际数据)
import costDataSource from "./dataCenterA/profit/costDataSource.vue"; //收入成本毛利(实际数据)

import MenuSetting from "./systemSetting/MenuSetting"; //菜单管理
import AccountSetting from "./systemSetting/AccountSetting"; //账号管理
import ConfigSetting from "./systemSetting/BasicDataSetting"; //字典管理
import CrontabSetting from "./systemSetting/CrontabSetting"; //定时任务管理
import GovSetting from "./systemSetting/GoveSetting"; //组织架构管理
import BasicDataDetailSetting from "./systemSetting/BasicDataDetailSetting"; //数据字典详情管理
import PostSetting from "./systemSetting/PostSetting"; //岗位管理
import RoleSetting from "./systemSetting/RoleSetting"; //角色管理
import GovMenuSetting from "./systemSetting/GovMenuSetting"; //多租户-组织菜单授权
import ApproveSetting from "./systemSetting/ApproveSetting"; //审批流设置
import DeptSetting from "./systemSetting/DeptSettingTree"; //部门管理
import latestNews from "./systemSetting/LatestNews"; //消息中心
import latestDocumentNews from "./systemSetting/LatestDocumentNews"; //公文消息中心

import AllContractMag from "./contract/AllContractMag"; //总包合同
import EditAllContract from "./contract/ContractDetail/AddAllContract"; //编辑总包合同
import AddAllContract from "./contract/ContractDetail/AddAllContract"; //新建总包合同
import SelectlContractDetail from "./contract/ContractDetail/SelectlContractDetail"; //查看总包合同
import ApproveContractDetail from "./contract/ContractDetail/SelectlContractDetail"; //审批总包合同
import ProjectMag from "./contract/ProjectMag"; //项目管理
import AddProjectOrder from "./contract/ProjectDetail/AddProjectOrder"; //新增项目立项单
import EditProjectOrder from "./contract/ProjectDetail/AddProjectOrder"; //编辑项目立项单
import SelectProjectOrder from "./contract/ProjectDetail/SelectProjectOrder"; //查看项目立项单
import ApproveProjectOrder from "./contract/ProjectDetail/SelectProjectOrder"; //审批项目立项单

import ApproveRule from "./contract/ProjectDetail/ApproveRule"; //立项审批制度
import ContractApproveRule from "./contract/subContract/ContractApproveRule"; //立项审批制度

import ProjectMsgSet from "./contract/ProjectDetail/ProjectMsgSet"; //工程项目配置
import serviceContractMag from "./contract/serviceContractMag"; //分项合同-劳务合同
import machineryContractMag from "./contract/machineryContractMag"; //分项合同-机械合同
import buyserviceContractMag from "./contract/buyContractMag"; //分项合同-材料合同
import otherserviceContractMag from "./contract/otherContractMag"; //分项合同-其他合同
import AddServiceContract from "./contract/subContract/AddServiceContract"; //创建分包-劳务合同
import EditServiceContract from "./contract/subContract/AddServiceContract"; //编辑分包-劳务合同

import AddSupplementary from "./contract/subContract/AddServiceContract"; //创建劳务合同-补充协议
import EditSupplementary from "./contract/subContract/AddServiceContract"; //编辑劳务合同-补充协议

import SelectServiceContract from "./contract/subContract/SelectServiceContract"; //查看分包-劳务合同
import ApproveServiceContract from "./contract/subContract/SelectServiceContract"; //审核分包-劳务合同
//基础数据
import ProjectNumList from "./basicData/ProjectNumList"; //工程里清单(总包)
import ProjectNumSubList from "./basicData/ProjectNumSubList"; //内部定额表(分包)

import materialNumList from "./basicData/materialNumList"; //物资采购
import rulesList from "./basicData/ruleManagerList"; //规章制度
import editRuledetail from "./basicData/editRuledetail"; //编辑规章制度

import supplierAListPage from "./supplierManager/supplierMag"; //合作单位管理
import addSupplierAPage from "./supplierManager/SupplierDetail/AddSupplierA"; //新增甲方信息
import editSupplierAPage from "./supplierManager/SupplierDetail/AddSupplierA"; //修改甲方信息
import supplierBSelfMag from "./supplierManager/supplierBSelfMag"; //乙方企业信息维护
import addSupplierBSelfPage from "./supplierManager/SupplierDetail/AddSupplierBSelf"; //乙方企业信息分类审核
import editSupplierBSelfPage from "./supplierManager/SupplierDetail/AddSupplierBSelf"; //修改乙方企业信息
import supplierBListPage from "./supplierManager/supplierBMag"; //我的企业信息
import addSupplierBPage from "./supplierManager/SupplierDetail/AddSupplierB"; //新增乙方企业信息
import editSupplierBPage from "./supplierManager/SupplierDetail/AddSupplierB"; //修改乙方企业信息
import supplierAApprove from "./supplierManager/supplierApproveMag"; //合作单位审核列表
import supplierBApprove from "./supplierManager/SupplierDetail/SupplierADetail"; //合作单位审核

import supplierAApproveDetail from "./supplierManager/SupplierDetail/SupplierADetail"; //合作单位审核详情
import supplierDetail from "./supplierManager/SupplierDetail/SupplierADetail"; //企业详情

import evaluateSupplierList from "./supplierManager/evaluateSupplierMsg/evaluateSupplier"; //合作单位评价
import evaluateAccountSet from "./supplierManager/evaluateSupplierMsg/subComponents/evaluateAccountSet"; //设置评价账号

import supplierSetTree from "./supplierManager/SupplierSetTree"; //合作单位分类
import supplierBAccount from "./supplierManager/supplierAccountSetting"; //合作单位账号管理

//--------------------------------------- 会议相关-----------------------------
// 会议提报单列表
import MeetingBillList from "./meeting/bill/MeetingBillList";
// 新增会议提报单
import AddMeetingBill from "./meeting/bill/AddMeetingBill";
// 查看会议提报单详情
import MeetingBillDetail from "./meeting/bill/MeetingBillDetail";
// 修改提报单
import MeetingBillEdit from "./meeting/bill/MeetingBillEdit";
// 综合议题会议
import GeneralMeetingList from "./meeting/manage/generalMeetingList";
import CreateGeneralMeeting from "./meeting/manage/createGeneralMeeting";
import GeneralMeetingDetail from "./meeting/manage/generalMeetingDetail";
import EditGeneralMeeting from "./meeting/manage/editGeneralMeeting";
// 其它议题会议
import OtherMeetingList from "./meeting/manage/otherMeetingList";
import CreateOtherMeeting from "./meeting/manage/createOtherMeeting";
import OtherMeetingDetail from "./meeting/manage/otherMeetingDetail";
import OtherMeetingEdit from "./meeting/manage/otherMeetingEdit";
// 群组列表
import GroupManage from "./group/groupList";
// 群组详情
import GroupDetail from "./group/groupDetail";

//------ 基础数据-供应商管理-----------------
import SupplierTable from "./basicData/supplierTable";

//------- 付款明细----------
import PaymentList from "./finance/PaymentList";
import CreatePayment from "./finance/CreatePayment";
import EditPayment from "./finance/EditPayment";
import PaymentDetail from "./finance/PaymentDetail";
import PaymentApplyList from "./finance/PaymentApplyList";

//----收款管理-------
import CollectionList from "./finance/CollectionList";
import CreateCollectionItem from "./finance/CreateCollectionItem";
import CollectionDetail from "./finance/CollectionDetail";
import EditCollectionItem from "./finance/EditCollectionItem";

//---收入成本管理-------
import IncomeCostList from "./finance/IncomeCostList";
import IncomeCostDetail from "./finance/IncomeCostDetail";
import CreateEarningItem from "./finance/CreateEarningItem";
import EditEarningItem from "./finance/EditEarningItem";

//------------jzy-InvoiceManager-start-----------
//销项发票申请列表
import salesInvoice from "./invoiceManager/salesManager/salesInvoice";
//销项发票申请详情
import salesInvoiceDetail from "./invoiceManager/salesManager/salesInvoiceDetail";
//销项发票——发起申请
import salesApply from "./invoiceManager/salesManager/sales-apply";
//销项发票——发票录入
import salesInput from "./invoiceManager/salesManager/sales-input";
//录入发票列表
import inputInvoice from "./invoiceManager/salesManager/inputInvoice";
//录入发票详情
import inputInvoiceDetail from "./invoiceManager/salesManager/inputInvoiceDetail";
//录入发票——确认收款
import inputConfirm from "./invoiceManager/salesManager/input-confirm";
//销项发票统计
import statistics from "./invoiceManager/salesManager/statistics";
//进项发票
import incomeInvoice from "./invoiceManager/incomeManager/incomeInvoice";
//进项发票详情
import incomeInvoiceDetail from "./invoiceManager/incomeManager/incomeInvoiceDetail";
//进项发票——发票录入
import incomeInput from "./invoiceManager/incomeManager/income-input";
//进项发票——设置审批流程
import incomeApprove from "./invoiceManager/incomeManager/income-approve";
//进项发票——审批流程详情
import approveDetails from "./invoiceManager/incomeManager/approve-details";
//报销审批
import reimbursement from "./invoiceManager/incomeManager/reimbursement";
//发票认领
import invoiceClaim from "./invoiceManager/incomeManager/invoiceClaim";
//claimTaxAmount
import claimTaxAmount from "./invoiceManager/incomeManager/claimTaxAmount";
//发票认领详情
import invoiceClaimDetail from "./invoiceManager/incomeManager/invoiceClaimDetail";
//进项发票统计
import incomeStatistics from "./invoiceManager/incomeManager/incomeStatistics";
//进项发票统计
import appletSetting from "./systemSetting/appletSetting";
//------------jzy-InvoiceManager-end-----------

//------------jzy-Engineering-start-----------
//事前审核
import beforExamine from "./engineering/beforehand/examine";
import beforIndex from "./engineering/beforehand/index";
import beforDeleteDetail from "./engineering/beforehand/deleteDetail";
import beforInfoDetails from "./engineering/beforehand/infoDetails";
import beforHistoryEdition from "./engineering/beforehand/historyEdition";
import inTheExamine from "./engineering/inTheMatter/examine";
import inTheIndex from "./engineering/inTheMatter/index";
import inTheDeleteDetail from "./engineering/inTheMatter/deleteDetail";
import inTheInfoDetails from "./engineering/inTheMatter/infoDetails";
import sporadicIndex from "./engineering/sporadic/index.vue";
import sporadicAdd from "./engineering/sporadic/addAndModify.vue";
import sporadicModify from "./engineering/sporadic/addAndModify.vue";
import sporadicDetail from "./engineering/sporadic/details.vue";
import expenditureSummary from "./engineering/expenditureSummary";
import expenditureStatistics from "./engineering/expenditureStatistics";
import projectSheet from "./engineering/projectSheet";

//其他直接费
import otherDirectFee from "./engineering/otherDirectFee/index";
import directDeleteDetail from "./engineering/otherDirectFee/deleteDetail";

//措施费
import measureFee from "./engineering/otherDirectFee/measureIndex";
import measureDeleteDetail from "./engineering/otherDirectFee/deleteDetail";

import inTheHistoryEdition from "./engineering/inTheMatter/historyEdition";
//------------jzy-Engineering-end-----------

//-------工作台-审批相关-start-------
//工作台
import workbench from "./workbench/workbench";
//待审批
import pendingApproval from "./workbench/pendingApproval";
//已驳回列表
import rejectApproval from "./workbench/rejectApproval";
//审批历史
import approvalHistory from "./workbench/approvalHistory";
//已提交待审批
import submitUnapproval from "./workbench/submitUnapproval";

//-------工作台-审批相关-end-------
//------------jzy-institution-start-----------
//制度管理
import lookUpIndex from "./institution/lookUp/index";
import lookUpDetails from "./institution/lookUp/details";
import manageIndex from "./institution/manage/index";
import manageAdd from "./institution/manage/addAndModify";
import manageModify from "./institution/manage/addAndModify";
import manageDetails from "./institution/manage/detail";
import cancelIndex from "./institution/cancel/index";
//公文管理
import documentManage from "./document/manage/index";
import documentManageAdd from "./document/manage/addAndModiify";
import documentManageModiify from "./document/manage/addAndModiify";
import documentManageDetails from "./document/manage/detailAndApprove";
import documentManagePrint from "./document/manage/print";
import documentApproval from "./document/approval/index";
import documentApprovalDetails from "./document/approval/details";
import incomingManage from "./document/incomingManage/index";
import incomingManageAdd from "./document/incomingManage/addAndModiify";
import incomingManageModiify from "./document/incomingManage/addAndModiify";
import incomingManageDetails from "./document/incomingManage/detailAndApprove";
import incomingManagePrint from "./document/incomingManage/print";
import incomingApproval from "./document/incomingApproval/index";
import incomingApprovalDetails from "./document/incomingApproval/details";
import documentClassifyManage from "./document/classify/index";

import generalOfficeAdd from "./document/manage/generalOffice/addAndModiify";
import generalOfficeModiify from "./document/manage/generalOffice/addAndModiify";
import generalOfficeDetails from "./document/manage/generalOffice/detailAndApprove";
import processingSendAndApprove from "./document/manage/processing/sendAndApprove";
import processingDetails from "./document/manage/processing/detail";

//采购计划
import bidPlan from "./inviteBids/bidPlan/index";
import bidPlanAdd from "./inviteBids/bidPlan/add";
import bidPlanDetail from "./inviteBids/bidPlan/detail";

//控制价审核
import controlPrice from "./inviteBids/controlPrice/index";
import controlPriceAdd from "./inviteBids/controlPrice/add";
import controlPriceDetail from "./inviteBids/controlPrice/detail";

//采购文件审核
import bidFile from "./inviteBids/bidFile/index";
import bidFileAdd from "./inviteBids/bidFile/add";
import bidFileDetail from "./inviteBids/bidFile/detail";

//联签单
import bidOrder from "./inviteBids/bidOrder/index";
import bidOrderAdd from "./inviteBids/bidOrder/add";
import bidOrderDetail from "./inviteBids/bidOrder/detail";

//采购台账
import bidLedger from "./inviteBids/bidLedger/index";
import bidLedgerAdd from "./inviteBids/bidLedger/add";
import bidLedgerDetail from "./inviteBids/bidLedger/detail";

//------------jzy-institution-end-----------
//菜单导航
import menuNav from "./home/menuNav";

export default {
  name: "ComponentLoader",
  components: {
    "app-accountsReceiveTotal": accountsReceiveTotal, //应收账款
    // "app-payProjectDeptDataSingle": payProjectDeptDataSingle, //项目部看板数据
    // "app-payProjectData": payProjectData, //项目看板
    "app-payDataSource": payDataSource, //应收账款数据源

    "app-payTotal": payTotal, //付款申请
    // "app-receiveProjectDeptDataSingle": receiveProjectDeptDataSingle, //付款申请项目部看板数据
    // "app-receiveProjectData": receiveProjectData, //付款看板
    "app-accountsReceiveDataSource": accountsReceiveDataSource, //付款申请数据源

    "app-accountsReceiveTotalA": accountsReceiveTotalA, //应收账款（实际数据）
    "app-payTotalA": payTotalA, //付款申请（实际数据）
    "app-costTotal": costTotal, //收入成本毛利
    "app-costDataSource": costDataSource, //应收账款数据源

    "app-menuSetting": MenuSetting, //菜单管理
    "app-accountSetting": AccountSetting, //应用管理
    "app-configSetting": ConfigSetting, //字典管理
    "app-crontabSetting": CrontabSetting, //定时任务管理
    "app-govSetting": GovSetting, //组织架构管理
    "app-postSetting": PostSetting, //岗位管理
    "app-roleSetting": RoleSetting, //角色管理
    "app-govMenuSetting": GovMenuSetting, //多租户-组织菜单授权
    "app-BasicDataDetailSetting": BasicDataDetailSetting, //数据字典详情管理
    "app-ApproveSetting": ApproveSetting, //审批流设置
    "app-buildSetting": DeptSetting, //部门管理
    "app-latestNews": latestNews, //消息中心
    "app-latestDocumentNews": latestDocumentNews, //消息中心

    //gongaiai 合同管理
    "pc-AllContractMag": AllContractMag, //总包合同
    "pc-editContract": EditAllContract, //编辑总包合同
    "pc-addContract": AddAllContract, //新建总包合同
    "pc-selectContract": SelectlContractDetail, //查看总包合同
    "pc-approveContract": ApproveContractDetail, //审核总包合同
    "pc-projectMag": ProjectMag, //项目管理
    "pc-addproject": AddProjectOrder, //新增项目立项单
    "pc-editproject": EditProjectOrder, //编辑项目立项单
    "pc-selectproject": SelectProjectOrder, //查看项目立项单
    "pc-approveproject": ApproveProjectOrder, //审批项目立项单
    "pc-ApproveRule": ApproveRule, //立项审批制度
    "pc-ContractApproveRule": ContractApproveRule, //合同审批制度
    "pc-ProjectMsgSet": ProjectMsgSet, //工程项目配置
    "pc-addSubContract": AddServiceContract, //新建劳务合同
    "pc-editSubContract": EditServiceContract, //编辑劳务合同

    "pc-AddSupplementary": AddSupplementary, //追加劳务合同补充协议
    "pc-EditSupplementary": EditSupplementary, //编辑劳务合同补充协议
    "pc-selectSubContract": SelectServiceContract, //查看劳务分项合同
    "pc-approveSubContract": ApproveServiceContract, //审批劳务分项合同
    "pc-buyContract": buyserviceContractMag, //材料合同
    "pc-otherContract": otherserviceContractMag, //其他合同
    "pc-subContractMag": serviceContractMag, //劳务分项合同
    "pc-machineryContractMag": machineryContractMag, //机械分项合同

    //基础数据
    "pc-projectNumListTab": ProjectNumList, //工程量清单
    "pc-projectNumSubListTab": ProjectNumSubList, //内部定额表

    "pc-materialNumListTab": materialNumList, //物资采购
    "pc-editrulesTab": editRuledetail, //规章制度
    "pc-rulesListTab": rulesList, //规章制度
    "pc-supplierTable": SupplierTable, // 供应商管理
    "pc-supplierAListPage": supplierAListPage, //供应商管理
    "pc-addSupplierAPage": addSupplierAPage, //录入甲方信息
    "pc-editSupplierAPage": editSupplierAPage, //录入甲方信息
    "pc-supplierSetTree": supplierSetTree, //合作单位分类
    "pc-supplierBAccount": supplierBAccount, //合作单位账号管理
    "pc-supplierAApprove": supplierAApprove, //合作单位审核列表
    "pc-supplierBApprove": supplierBApprove, //合作单位审核
    "pc-supplierAApproveDetail": supplierAApproveDetail, //合作单位审核详情
    "pc-supplierDetail": supplierDetail, //企业详情

    "pc-supplierBListPage": supplierBListPage, //我的企业信息
    "pc-addSupplierBSelfPage": addSupplierBSelfPage, //录入乙方企业信息及审核
    "pc-editSupplierBSelfPage": editSupplierBSelfPage, //修改乙方企业信息及审核

    "pc-evaluateSupplierList": evaluateSupplierList, //合作单位评价
    "pc-evaluateAccountSet": evaluateAccountSet, //设置评价账号

    "pc-supplierBSelfMag": supplierBSelfMag, //企业信息维护
    "pc-addSupplierBPage": addSupplierBPage, //录入乙方企业信息
    "pc-editSupplierBPage": editSupplierBPage, //录入乙方企业信息

    // -------------------会议相关
    "pc-MeetingBillList": MeetingBillList, //会议提报单列表
    "pc-AddMeetingBill": AddMeetingBill, // 新增会议提报单
    "pc-MeetingBillDetail": MeetingBillDetail, //查看会议提报单详情
    "pc-MeetingBillEdit": MeetingBillEdit,
    "pc-GeneralMeetingList": GeneralMeetingList,
    "pc-OtherMeetingList": OtherMeetingList,
    "pc-CreateGeneralMeeting": CreateGeneralMeeting,
    "pc-GeneralMeetingDetail": GeneralMeetingDetail,
    "pc-EditGeneralMeeting": EditGeneralMeeting,
    "pc-CreateOtherMeeting": CreateOtherMeeting,
    "pc-OtherMeetingDetail": OtherMeetingDetail,
    "pc-OtherMeetingEdit": OtherMeetingEdit,
    "app-groupManage": GroupManage, // 群组列表
    "app-groupDetail": GroupDetail, // 群组详情，可以查看和修改

    // ---- 收款管理
    "pc-collectionlist": CollectionList, // 收款管理-列表
    "pc-createcollection": CreateCollectionItem, // 创建新的收款记录
    "pc-editcollection": EditCollectionItem, // 编辑已有的收款记录
    "pc-collectiondetail": CollectionDetail, // 收款记录详情
    //------付款明细
    "pc-paymentlist": PaymentList, // 付款明细列表
    "pc-createpayment": CreatePayment, // 新建付款明细
    "pc-editpayment": EditPayment, // 编辑付款明细
    "pc-paymentdetail": PaymentDetail, //  付款明细详情
    "pc-paymentapplylist": PaymentApplyList, // 付款申请列表
    //-----收入成本管理
    "pc-incomecostlist": IncomeCostList, // 收入成本管理-列表页
    // "pc-incomecostlist": EditEarningItem, // TODO：方便测试
    "pc-incomeconstdetail": IncomeCostDetail, // 收入成本管理-查看详情
    "pc-CreateEarningItem": CreateEarningItem, // 收入成本管理-新建收入记录
    "pc-EditEarningItem": EditEarningItem, //收入成本管理-编辑收入记录

    //------------jzy-InvoiceManager-start-----------
    "pc-salesInvoice": salesInvoice, //销项发票申请列表
    "pc-salesInvoiceDetail": salesInvoiceDetail, //销项发票申请详情
    "pc-salesApply": salesApply, //销项发票————发起申请
    "pc-salesInput": salesInput, //销项发票————发票录入
    "pc-inputInvoice": inputInvoice, //录入发票列表
    "pc-inputInvoiceDetail": inputInvoiceDetail, //录入发票详情
    "pc-inputConfirm": inputConfirm, //录入发票————确认收款
    "pc-statistics": statistics, //销项发票统计
    "pc-incomeInvoice": incomeInvoice, //进项发票
    "pc-incomeInvoiceDetail": incomeInvoiceDetail, //进项发票
    "pc-incomeInput": incomeInput, //进项发票————发票录入
    "pc-incomeApprove": incomeApprove, //进项发票————发票录入
    "pc-approveDetails": approveDetails, //进项发票————审批详情
    "pc-reimbursement": reimbursement, //报销审批
    "pc-invoiceClaim": invoiceClaim, //发票认领
    "pc-claimTaxAmount": claimTaxAmount, //发票认领进项税额
    "pc-invoiceClaimDetail": invoiceClaimDetail, //发票认领详情
    "pc-incomeStatistics": incomeStatistics, //进项发票统计
    "pc-appletSetting": appletSetting, //小程序管理
    //------------jzy-InvoiceManager-end-----------

    //------------jzy-Engineering-start-----------
    "pc-beforExamine": beforExamine, //事前审核
    "pc-beforIndex": beforIndex, //事前成本
    "pc-beforDeleteDetail": beforDeleteDetail, //删除细目
    "pc-beforInfoDetails": beforInfoDetails, //事前详情——细目（总包）信息
    "pc-beforHistoryEdition": beforHistoryEdition, //事前历史版本
    "pc-inTheExamine": inTheExamine, //事中审核
    "pc-inTheIndex": inTheIndex, //事中成本
    "pc-inTheHistoryEdition": inTheHistoryEdition, //事中历史版本
    "pc-inTheDeleteDetail": inTheDeleteDetail, //事中删除细目
    "pc-inTheInfoDetails": inTheInfoDetails, //事中详情——细目（总包）信息
    "pc-sporadicIndex": sporadicIndex, //零星工程量——首页
    "pc-sporadicAdd": sporadicAdd, //零星工程量——新增
    "pc-sporadicModify": sporadicModify, //零星工程量——修改
    "pc-sporadicDetail": sporadicDetail, //零星工程量——详情
    "pc-expenditureSummary": expenditureSummary, //成本支出汇总表
    "pc-expenditureStatistics": expenditureStatistics, //成本支出统计表
    "pc-projectSheet": projectSheet, //工程结算单

    "pc-otherDirectFee": otherDirectFee, //其他直接费
    "pc-directDeleteDetail": directDeleteDetail, //其他直接费

    "pc-measureFee": measureFee, //措施费
    "pc-measureDeleteDetail": measureDeleteDetail, //删除措施费

    //------------jzy-Engineering-end-----------
    //------------jzy-institution-start-----------
    "pc-lookUpIndex": lookUpIndex, //制度查阅
    "pc-lookUpDetails": lookUpDetails, //制度查阅详情
    "pc-manageIndex": manageIndex, //制度管理
    "pc-manageAdd": manageAdd, //制度管理新增
    "pc-manageModify": manageModify, //制度管理修改
    "pc-manageDetails": manageDetails, //制度管理详情
    "pc-cancelIndex": cancelIndex, //制度作废

    "pc-documentManage": documentManage, //公文管理
    "pc-documentManageAdd": documentManageAdd, //公文管理-新增
    "pc-documentManageModiify": documentManageModiify, //公文管理-修改
    "pc-documentManageDetails": documentManageDetails, //公文详情
    "pc-documentManagePrint": documentManagePrint, //公文管理-打印
    "pc-documentApproval": documentApproval, //公文审批
    "pc-documentApprovalDetails": documentApprovalDetails, //公文审批-详情
    "pc-incomingManage": incomingManage, //收文管理
    "pc-incomingManageAdd": incomingManageAdd, //收文管理-新增
    "pc-incomingManageModiify": incomingManageModiify, //收文管理-修改
    "pc-incomingManageDetails": incomingManageDetails, //收文管理-详情
    "pc-incomingManagePrint": incomingManagePrint, //收文管理-打印
    "pc-incomingApproval": incomingApproval, //收文审批
    "pc-incomingApprovalDetails": incomingApprovalDetails, //收文审批-详情
    "pc-documentClassifyManage": documentClassifyManage, //公文分类管理
    "pc-generalOfficeAdd": generalOfficeAdd, //综合办发文
    "pc-generalOfficeModiify": generalOfficeModiify, //综合办发文修改
    "pc-generalOfficeDetails": generalOfficeDetails, //综合办发文详情
    "pc-processingSendAndApprove": processingSendAndApprove, //收文处理-直接发送和提交审批
    "pc-processingDetails": processingDetails, //收文处理-详情
    //------------jzy-institution-end-----------
    //采购管理
    "pc-bidPlan": bidPlan, //采购计划
    "pc-bidPlanAdd": bidPlanAdd, //新增采购计划
    "pc-bidPlanEdit": bidPlanAdd, //编辑采购计划
    "pc-bidPlanDetail": bidPlanDetail, //采购计划详情

    "pc-controlPrice": controlPrice, //控制价审核
    "pc-controlPriceAdd": controlPriceAdd, //新增控制价审核
    "pc-controlPriceEdit": controlPriceAdd, //编辑控制价审核
    "pc-controlPriceDetail": controlPriceDetail, //控制价审核详情

    "pc-bidFile": bidFile, //采购文件审核
    "pc-bidFileAdd": bidFileAdd, //新增采购文件
    "pc-bidFileEdit": bidFileAdd, //编辑采购文件
    "pc-bidFileDetail": bidFileDetail, //采购文件详情

    "pc-bidOrder": bidOrder, //联签单
    "pc-bidOrderAdd": bidOrderAdd, //新增联签单
    "pc-bidOrderEdit": bidOrderAdd, //编辑联签单
    "pc-bidOrderDetail": bidOrderDetail, //联签单详情

    "pc-bidLedger": bidLedger, //采购台账
    "pc-bidLedgerAdd": bidLedgerAdd, //新增采购台账
    "pc-bidLedgerEdit": bidLedgerAdd, //编辑采购台账
    "pc-bidLedgerDetail": bidLedgerDetail, //采购台账详情

    //-------工作台 审批  start------------------------
    "pc-workbench": workbench, //工作台
    "pc-pendingApproval": pendingApproval, //待审批
    "pc-rejectedApproval": rejectApproval, //已驳回
    "pc-approvalHistory": approvalHistory, //审批历史
    "pc-submitUnapproval": submitUnapproval, //已提交待审批
    //-------工作台 审批  end------------------------

    "pc-menuNav": menuNav, //首页菜单导航
  },
  props: {
    comObj: {
      type: Object,
      default: () => {},
    },
    menuCode: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      useCom: "",
      tabName: "",
      title: "",
      uniCode: "", //用于多开同一页面唯一编码
    };
  },

  created() {
    let { title, name, component } = this.comObj;
    this.useCom = component;
    this.tabName = name;
    this.title = title;
    this.uniCode = this.comObj.uniCode;
  },

  methods: {
    comActiveAction(comName, tabRouteParam, menuCode) {
      if (this.useCom == comName) {
        if (this.$refs.cominstance.onActive) {
          if (tabRouteParam) {
            this.store.set(`tabRouteParam.${name}`, tabRouteParam);
            this.$refs.cominstance.tabRouteParam = tabRouteParam;
            this.$refs.cominstance.tabName = this.tabName;
          }
          // console.log('当前的菜单编码： ' + menuCode);
          this.$refs.cominstance.onActive(menuCode);
        }
      }
    },
    refreshPage(menuCode) {
      if (this.$refs.cominstance.onActive) {
        // console.log('当前的菜单编码： ' + menuCode);
        this.$refs.cominstance.onActive(menuCode);
      }
    },
  },

  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.componentLoader {
  height: 100%;
  background-color: #e9f4fa;
  overflow: auto;
}
</style>
